import styled from 'styled-components';

const Button = styled.button.attrs({
    className: 'btn',
})`
    background: var(--brand);
    border-radius: var(--borderRadiusSm);
    padding: 16px 32px;
    color: var(--white);
    font-family: var(--fontPoppins);
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.02em;
    text-transform: capitalize;
    cursor: pointer;
    transition: 0.3s all;

    &:hover {
        opacity: 0.6;
    }

    &:active {
        opacity: 0.3;
    }

    &:disabled {
        opacity: 0.7;
        cursor: initial;
    }

    &.btn-transparent {
        outline: 1.5px solid #e6e6e6 !important;
        background: transparent;
        color: #0a0a0a40;

        &:hover {
            opacity: 0.8;
        }

        &:active {
            opacity: 0.5;
        }
    }

    &.btn-outline {
        background: transparent;
        color: var(--brand);
        border: 1.5px solid var(--brand);
    }

    &.with-icon .content {
        display: inline-flex;
        align-items: center;
        gap: 10px;
    }

    &.dropdown {
        padding: 17px 24px;
    }

    &.btn-link {
        background: transparent;
        color: var(--brand);
        font-weight: 400;
        font-size: 13px;
        padding: 0;
        letter-spacing: 0;
    }

    &.loading {
        position: relative;

        .content {
            visibility: hidden;
            opacity: 0;
        }

        &:after {
            content: '';
            position: absolute;
            width: 30px;
            height: 30px;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            border-radius: 50%;
            display: inline-block;
            border-top: 3px solid #fff;
            border-right: 3px solid transparent;
            box-sizing: border-box;
            animation: button-loading-spinner 1s linear infinite;
        }
    }

    @keyframes button-loading-spinner {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

export default Button;
